import { useHttp } from '@/api';
import { httpApi } from '@/api/api';
import { t } from "@/locales";
import { STR_EMPTY } from '@/utils/const';
import { Message } from "@tellus/component";
/**
 * ZIP型出力書取得
 */
export function outputExcelToZip(apiKbn, data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(apiKbn, data)
      .then(res => {
        const decodedBytes = atob(res.ResultData);
        const uint8Array = new Uint8Array(decodedBytes.length);

        for (let i = 0; i < decodedBytes.length; i++) {
          uint8Array[i] = decodedBytes.charCodeAt(i);
        }

        const zipBlob = new Blob([uint8Array], {
          type: res.ResultType,
        });
        const url = window.URL.createObjectURL(zipBlob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", res.ResultName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        Message.showSuccess(t("message.COMMON_MESSAGE.OUTPUT_SUCCESS"));
        resolve(res.ResultData)
      })
      .catch(err => {
        if (err?.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.OUTPUT_FAILURE"));
          }
        reject(err)
      })
  })
}

/**
 * TXT型出力書取得
 */
export function outputTxt(fileName, msg) {
  return new Promise((resolve, reject) => {
    try {
      const content = msg;
      const blob = new Blob([content], { type: "text/plain;charset=utf-8" });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);
      resolve();
    } catch (error) {
      reject(error);
    }
  })
}

/**
 * 共通API
 */
export function commonApi(apiKbn,data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(apiKbn, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}

// ADD 2025/03/19 ZLL 課題_出力後、状態の自動変更の追加 start↓
/**
 * 出力後、状態の更新（手配：新規⇒手配済み、納品：新規⇒納品済み、請求：新規⇒請求済み）
 */
export function updateStatusAfterOutput(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.UpdateStatusAfterOutput, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// ADD 2025/03/19 ZLL 課題_出力後、状態の自動変更の追加 end↑

// ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
// 課題_備考機能の追加
// 「今回の追加備考」画面を表示する
export function showRemarksUpdDialog(vm, quoteNo, prodNo, aodProdRemarksSum) {
  let remarksAll = STR_EMPTY;
  //備考が空のチェック
  let remarksNullChk = aodProdRemarksSum == null || aodProdRemarksSum == STR_EMPTY || aodProdRemarksSum == undefined;
 return vm.$prompt("", t("resource.REMARKS_ADD.TITLE"), {
    confirmButtonText: t("resource.button.sure"),
   cancelButtonText: t("resource.button.cancel"),
   inputType: 'textarea',
    inputAttributes: {
    style: "height: 80px;"
  },
    inputValidator: (value) => {
      //空、「はい」ボタンを押下の場合、エラーメッセージを表示する
      if (!value) {
        return t("message.REMARKS_ADD.NULL_CHECK");
      }
      //「■」を含む場合、エラーメッセージを表示する
       if (value.includes('■')) {
        return t("message.REMARKS_ADD.INPUT_CHECK");
       }
      // 備考の桁数の確認
      if ((!remarksNullChk?aodProdRemarksSum.length:0) + value.length +1 > 2000) {
        return t("message.REMARKS_ADD.MAX_LENGTH_2000");
      }

      // 入力内容の長さが200文字を超えるかどうかをチェック
      if (value.length > 200) {
        return t("message.REMARKS_ADD.MAX_LENGTH_200");
      }
      return true;

    },
  })
   .then(({ value }) => {
      // \n ⇒　空 に変換
      let jsonString = JSON.stringify(value);
      if (jsonString.includes("\\n")) {
        value = JSON.parse(jsonString.replace(/\\n/g, " "));
      }

     if (remarksNullChk) {
       remarksAll = value;
     } else {
       remarksAll = aodProdRemarksSum + "■" + value;
      }

      return new Promise((resolve, reject) => {
        useHttp()
          .request(httpApi.UpdateAodRemarks, {aodQuoteNo: quoteNo, aodProdNo: prodNo, aodProdRemarks:value})
          .then(res => {
            Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
            return resolve(remarksAll);
          })
          .catch(err => {
            if (err.data != null && err.data.Messages[0]!= null) {
             Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
             );
            } else {
              Message.showError(
                t("message.COMMON_MESSAGE.UPDATE_FAILURE")
              );
            }
              return resolve(STR_EMPTY);
          })
      })
   }).catch(() => {
      return Promise.resolve(aodProdRemarksSum);
   })
}
// ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

// ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
//共通備考の調整(備考の表示と保存)
export function showRemarksDialog(vm, quoteNo, prodNo, initVal, aodProdRemarksSum, aodUpdateTime) {
  let currentInputValue = aodProdRemarksSum;
  return new Promise((outerResolve) => {
    const openPrompt = () => {
      vm.$prompt("", t("resource.REMARKS_DETAIL.TITLE"), {
        confirmButtonText: t("resource.button.sure"),
        cancelButtonText: t("resource.button.cancel"),
        inputType: 'textarea',
        inputValue: currentInputValue,
        closeOnHashChange: true,
        // inputAttributes: { style: "height: 80px;",  rows: 10},
        closeOnClickModal: false,
        customClass: 'custom-prompt',
        inputValidator: (value) => {
          if (!!value&&value.length > 2000) {
            return t("message.REMARKS_DETAIL.MAX_LENGTH_2000");
          }
          return true;
        },
      })
        .then(async ({ value }) => {
          currentInputValue = value;
          const isModified = (!currentInputValue ? "" : currentInputValue) !== (!aodProdRemarksSum ? "" : aodProdRemarksSum);
          if (isModified&&currentInputValue.trim() == STR_EMPTY) {
            try {
              await vm.$confirm(
                t("message.REMARKS_DETAIL.INPUT_NULL_CHECK"),
                "",
                { confirmButtonText: t("resource.button.sure"), cancelButtonText: t("resource.button.cancel"), type: 'warning' }
              );
            } catch {
              openPrompt();
              return;
            }
          }

        return useHttp().request(httpApi.UpdateAodRemarks, {
          aodQuoteNo: quoteNo,
          aodProdNo: prodNo,
          aodProdRemarks: value,
          aodUpdateTime: aodUpdateTime
        })
          .then(res => {
          Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
          outerResolve(res);
        })
        .catch(err => {
          if (err.data != null && err.data.Messages[0] != null) {
            Message.showError(t('message.COMMON_MESSAGE.' + err.data.Messages[0].Message))
            outerResolve(err.data.Data)
          } else {
            Message.showError(t('message.COMMON_MESSAGE.UPDATE_FAILURE'))
            outerResolve(STR_EMPTY)
          }
        });
      })
        .catch(async (action) => {
          if (action === 'cancel' || action === 'close') {
            currentInputValue = document.querySelector('.el-message-box__input textarea').value;

            const isModified = (!currentInputValue ? "" : currentInputValue) !== (!aodProdRemarksSum ? "" : aodProdRemarksSum);
          if (isModified) {
            try {
              await vm.$confirm(
                t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
                "",
                { confirmButtonText: t("resource.button.sure"), cancelButtonText: t("resource.button.cancel"), type: 'warning' }
              );
              outerResolve();
            } catch {
              openPrompt();
            }
          } else {
            outerResolve();
          }
          }
      });
    };
    openPrompt();
  });
}
// ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
